<div id="iframe-portalV1">
  <div class="layout-main">
    <div class="container-fluid">

      <nav class="navbar navbar-expand mb-2" id="breadcrumb-sf-1">
        <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
          <ol class="breadcrumb ol-sf-1">
            <li class="breadcrumb-item">
              <a routerLink="/mckay/{{authenticationService.getUserCurrent().company.uniqid}}">Home</a>
            </li>
            <li class="breadcrumb-item">
              <a routerLink="/exchanges">List Exchanges</a>
            </li>
            <li *ngIf="isEditOrShowAction" class="breadcrumb-item">{{ dadName }}</li>
            <li *ngIf="action === 'new'" class="breadcrumb-item">New</li>
          </ol>
        </nav>
      </nav>

      <div class="symbols-title-row">
        <h3 class="mb-0">
          <b *ngIf="action === 'edit'">Edit DAD Config</b>
          <b *ngIf="action === 'show'">DAD Config</b>
          <b *ngIf="action === 'new'">New DAD Config</b>
        </h3>
        <button (click)="onSubmit()" *ngIf="action !== 'show'" [disabled]="dadConfigForm?.pristine || dadConfigForm?.invalid"
                class="btn btn-primary">
          <i class="fa fa-save mr-1"></i>Save
        </button>
      </div>

      <div *ngIf="loadError" class="alert alert-danger">
        The DAD config could not be loaded. Please try again later.
      </div>

      <div *ngIf="errorUpdate" class="alert alert-danger alert-dismissible fade show">
        {{ errorString }}
        <button (click)="errorUpdate = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="success && !loading" class="alert alert-success alert-dismissible fade show">
        <ng-container *ngIf="successUpdate">The DAD config was updated successfully.</ng-container>
        <ng-container *ngIf="successAdd">The DAD config was created successfully.</ng-container>
        <ng-container *ngIf="deletedDadProductSuccess">The dad product was deleted successfully.</ng-container>
        <ng-container *ngIf="deletedDadProductPriceSuccess">The dad product price was deleted successfully.</ng-container>
        <button (click)="success = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <p-confirmDialog key="deleteDadProduct" styleClass="delete-confirm-dialog" [baseZIndex]="10000"></p-confirmDialog>
      <p-confirmDialog key="deleteDadProductPrice" styleClass="delete-confirm-dialog" [baseZIndex]="10000"></p-confirmDialog>

      <form *ngIf="!loading" [formGroup]="dadConfigForm">
        <div class="config-section">
          <div class="config-section-header" (click)="sectionGeneral = !sectionGeneral">
            <span><i class="fa fa-info-circle mr-2"></i>General</span>
            <i class="fa fa-chevron-down section-chevron" [class.collapsed]="!sectionGeneral"></i>
          </div>
          <div class="config-section-body" *ngIf="sectionGeneral">

            <div class="field-group">
              <label for="exchangesNames">Exchanges</label>
              <p-multiSelect [options]="listExchangesDropDown" [style]="{width: '100%'}"
                             defaultLabel="Select exchanges" formControlName="exchangesNames"
                             id="exchangesNames" maxSelectedLabels="5"
                             appendTo="body" panelStyleClass="sym-select-panel"></p-multiSelect>
            </div>

            <div class="two-col-grid">
              <div class="field-group">
                <label for="exchangeNameInTitle">Exchange name in title</label>
                <input class="form-control" formControlName="exchangeNameInTitle" id="exchangeNameInTitle"
                       placeholder="Exchange name in title" type="text">
                <span *ngIf="dadConfigForm.get('exchangeNameInTitle').touched && dadConfigForm.get('exchangeNameInTitle').invalid"
                      class="field-error">Required.</span>
              </div>
              <div class="field-group">
                <label for="reportType">Report type</label>
                <p-dropdown [options]="reportTypeList" formControlName="reportType" id="reportType"
                            [style]="{width: '100%'}" appendTo="body" panelStyleClass="sym-select-panel"></p-dropdown>
              </div>
            </div>

            <div class="two-col-grid">
              <div class="field-group">
                <label for="timezone">Timezone</label>
                <p-dropdown [options]="timezonesList" formControlName="timezone" id="timezone"
                            [style]="{width: '100%'}" appendTo="body" panelStyleClass="sym-select-panel"></p-dropdown>
              </div>
              <div class="field-group">
                <label for="note">Note</label>
                <input class="form-control" formControlName="note" id="note"
                       placeholder="Optional note" type="text">
              </div>
            </div>

          </div>
        </div>
        <div class="config-section">
          <div class="config-section-header" (click)="sectionSchedule = !sectionSchedule">
            <span><i class="fa fa-calendar mr-2"></i>Schedule</span>
            <i class="fa fa-chevron-down section-chevron" [class.collapsed]="!sectionSchedule"></i>
          </div>
          <div class="config-section-body" *ngIf="sectionSchedule">

            <div class="schedule-col-headers">
              <span></span>
              <span class="schedule-col-label">Day</span>
              <span class="schedule-col-label">Time</span>
            </div>

            <div class="schedule-row">
              <span class="schedule-label">Form sent</span>
              <div>
                <input class="form-control" formControlName="creationDay" id="creationDay" min="1" type="number">
                <div *ngIf="dadConfigForm.get('creationDay').touched && dadConfigForm.get('creationDay').errors" class="field-error">
                  <span *ngIf="dadConfigForm.get('creationDay').errors.required">Required.</span>
                  <span *ngIf="dadConfigForm.get('creationDay').errors.pattern">Digits only.</span>
                </div>
              </div>
              <p-calendar (onSelect)="onTimePick($event, 'creationTime')" [timeOnly]="true"
                          dataType="string" formControlName="creationTime" id="creationTime" appendTo="body" panelStyleClass="sym-datepicker"></p-calendar>
            </div>

            <div class="schedule-row">
              <span class="schedule-label">Auto report reminder</span>
              <div>
                <input class="form-control" formControlName="autoReportFirstReminderDay"
                       id="autoReportFirstReminderDay" min="1" type="number">
                <div *ngIf="dadConfigForm.get('autoReportFirstReminderDay').touched && dadConfigForm.get('autoReportFirstReminderDay').errors" class="field-error">
                  <span *ngIf="dadConfigForm.get('autoReportFirstReminderDay').errors.required">Required.</span>
                  <span *ngIf="dadConfigForm.get('autoReportFirstReminderDay').errors.pattern">Digits only.</span>
                </div>
              </div>
              <p-calendar (onSelect)="onTimePick($event, 'autoReportFirstReminderTime')" [timeOnly]="true"
                          dataType="string" formControlName="autoReportFirstReminderTime"
                          id="autoReportFirstReminderTime" appendTo="body" panelStyleClass="sym-datepicker"></p-calendar>
            </div>

            <div class="schedule-row">
              <span class="schedule-label">Second reminder</span>
              <div>
                <input class="form-control" formControlName="secondReminderDay" id="secondReminderDay"
                       min="1" type="number">
                <div *ngIf="dadConfigForm.get('secondReminderDay').touched && dadConfigForm.get('secondReminderDay').errors" class="field-error">
                  <span *ngIf="dadConfigForm.get('secondReminderDay').errors.required">Required.</span>
                  <span *ngIf="dadConfigForm.get('secondReminderDay').errors.pattern">Digits only.</span>
                </div>
              </div>
              <p-calendar (onSelect)="onTimePick($event, 'secondReminderTime')" [timeOnly]="true"
                          dataType="string" formControlName="secondReminderTime" id="secondReminderTime" appendTo="body" panelStyleClass="sym-datepicker"></p-calendar>
            </div>

            <div class="schedule-row">
              <span class="schedule-label">Third reminder</span>
              <div>
                <input class="form-control" formControlName="thirdReminderDay" id="thirdReminderDay"
                       min="1" type="number">
                <div *ngIf="dadConfigForm.get('thirdReminderDay').touched && dadConfigForm.get('thirdReminderDay').errors" class="field-error">
                  <span *ngIf="dadConfigForm.get('thirdReminderDay').errors.required">Required.</span>
                  <span *ngIf="dadConfigForm.get('thirdReminderDay').errors.pattern">Digits only.</span>
                </div>
              </div>
              <p-calendar (onSelect)="onTimePick($event, 'thirdReminderTime')" [timeOnly]="true"
                          dataType="string" formControlName="thirdReminderTime" id="thirdReminderTime" appendTo="body" panelStyleClass="sym-datepicker"></p-calendar>
            </div>

            <div class="schedule-row">
              <span class="schedule-label">Quincy cutoff start</span>
              <div>
                <input class="form-control" formControlName="quincyCutoffStartDay" id="quincyCutoffStartDay"
                       min="1" type="number">
                <div *ngIf="dadConfigForm.get('quincyCutoffStartDay').touched && dadConfigForm.get('quincyCutoffStartDay').errors" class="field-error">
                  <span *ngIf="dadConfigForm.get('quincyCutoffStartDay').errors.required">Required.</span>
                  <span *ngIf="dadConfigForm.get('quincyCutoffStartDay').errors.pattern">Digits only.</span>
                </div>
              </div>
              <p-calendar (onSelect)="onTimePick($event, 'quincyCutoffStartTime')" [timeOnly]="true"
                          dataType="string" formControlName="quincyCutoffStartTime"
                          id="quincyCutoffStartTime" appendTo="body" panelStyleClass="sym-datepicker"></p-calendar>
            </div>

            <hr class="section-divider">

            <div class="two-col-grid">
              <div class="field-group">
                <label for="quincyCutoffPeriod">Quincy cutoff period</label>
                <input class="form-control" formControlName="quincyCutoffPeriod" id="quincyCutoffPeriod"
                       placeholder="e.g. 4" type="number">
                <div *ngIf="dadConfigForm.get('quincyCutoffPeriod').touched && dadConfigForm.get('quincyCutoffPeriod').errors" class="field-error">
                  <span *ngIf="dadConfigForm.get('quincyCutoffPeriod').errors.required">Required.</span>
                </div>
              </div>
              <div class="field-group">
                <label for="jumpCheckThreshold">Jump check threshold (%)</label>
                <input class="form-control" formControlName="jumpCheckThreshold" id="jumpCheckThreshold"
                       placeholder="e.g. 10" type="number">
                <div *ngIf="dadConfigForm.get('jumpCheckThreshold').touched && dadConfigForm.get('jumpCheckThreshold').errors" class="field-error">
                  <span *ngIf="dadConfigForm.get('jumpCheckThreshold').errors.required">Required.</span>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="config-section">
          <div class="config-section-header" (click)="sectionSettings = !sectionSettings">
            <span><i class="fa fa-sliders mr-2"></i>Settings</span>
            <i class="fa fa-chevron-down section-chevron" [class.collapsed]="!sectionSettings"></i>
          </div>
          <div class="config-section-body" *ngIf="sectionSettings">
            <div class="toggles-grid">
              <label class="toggle-item" for="canAutoReport">
                <input type="checkbox" formControlName="canAutoReport" id="canAutoReport">
                <span class="toggle-label">Can auto report</span>
              </label>
              <label class="toggle-item" for="canSelfReport">
                <input type="checkbox" formControlName="canSelfReport" id="canSelfReport">
                <span class="toggle-label">Can self-report</span>
              </label>
              <label class="toggle-item" for="canReportAsSubvendor">
                <input type="checkbox" formControlName="canReportAsSubvendor" id="canReportAsSubvendor">
                <span class="toggle-label">Can report as subvendor</span>
              </label>
              <label class="toggle-item" for="canExempt">
                <input type="checkbox" formControlName="canExempt" id="canExempt">
                <span class="toggle-label">Can exempt</span>
              </label>
              <label class="toggle-item" for="canCarryForward">
                <input type="checkbox" formControlName="canCarryForward" id="canCarryForward">
                <span class="toggle-label">Can carry forward</span>
              </label>
              <label class="toggle-item" for="active">
                <input type="checkbox" formControlName="active" id="active">
                <span class="toggle-label">Active</span>
              </label>
            </div>
          </div>
        </div>
        <div *ngIf="isEditOrShowAction" class="config-section">
          <div class="config-section-header" (click)="sectionProducts = !sectionProducts">
            <span><i class="fa fa-tags mr-2"></i>Dad Products</span>
            <i class="fa fa-chevron-down section-chevron" [class.collapsed]="!sectionProducts"></i>
          </div>
          <div class="config-section-body" *ngIf="sectionProducts">

            <ng-container *ngFor="let market of markets">
              <div class="market-section">
                <div class="market-header">
                  <h5 class="market-name">{{ market.name }}</h5>
                  <button *ngIf="action === 'edit'" class="btn btn-primary btn-sm" (click)="showPopUp(market)"
                          type="button">
                    <i class="fa fa-plus"></i> Add Product
                  </button>
                </div>

                <div *ngIf="market.dadProducts.length === 0" class="empty-products">
                  No products defined for this market.
                </div>

                <div *ngFor="let dadProduct of market.dadProducts" class="product-card">
                  <div class="product-card-header">
                    <div class="product-info">
                      <span class="product-type-badge">{{ dadProduct.productType }}</span>
                      <span class="product-type-badge">{{ dadProduct.rebillingProductType }}</span>
                      <span class="product-type-badge" [style.background-color]="'#' + dadProduct.rebillingColor">Report color</span>
                      <span class="product-code">{{ dadProduct.productCode }}</span>
                      <span class="product-date">Internal: {{ dadProduct.internalProductCode }}</span>
                      <span class="product-date">Valid from {{ dadProduct.startDate | date: "MMM dd, y" }}</span>
                    </div>
                    <div *ngIf="action === 'edit'" class="product-actions">
                      <button class="btn btn-sm btn-outline-secondary"
                              (click)="showPopUp(market, dadProduct, true)"
                              pTooltip="Edit product" tooltipPosition="top">
                        <i class="fa fa-pencil"></i> Edit
                      </button>
                      <button class="btn btn-sm btn-outline-danger"
                              (click)="deleteDadProduct(market, dadProduct)"
                              pTooltip="Delete product" tooltipPosition="top">
                        <i class="fa fa-trash"></i> Delete
                      </button>
                    </div>
                  </div>

                  <div class="product-card-body">
                    <div class="prices-header">
                      <span class="prices-label">Prices</span>
                      <button *ngIf="action === 'edit'" class="btn btn-sm btn-outline-primary"
                              (click)="showProductPricePopUp(market, dadProduct)" type="button">
                        <i class="fa fa-plus"></i> Add Price
                      </button>
                    </div>

                    <div *ngIf="dadProduct.dadProductPrices.length === 0" class="empty-prices">
                      No prices defined for this product.
                    </div>

                    <div *ngIf="dadProduct.dadProductPrices.length > 0" class="symbols-market-table mb-0">
                    <p-table [value]="dadProduct.dadProductPrices" [autoLayout]="true" [rowHover]="true">
                      <ng-template pTemplate="header">
                        <tr>
                          <th>Amount</th>
                          <th>Currency</th>
                          <th>Valid from</th>
                          <th *ngIf="action === 'edit'"></th>
                        </tr>
                      </ng-template>
                      <ng-template let-price pTemplate="body">
                        <tr>
                          <td>{{ price.amount }}</td>
                          <td>{{ price.currency }}</td>
                          <td>{{ price.startDate | date: "MMM dd, y" }}</td>
                          <td *ngIf="action === 'edit'" class="price-delete-cell">
                            <button class="btn btn-sm btn-outline-danger"
                                    (click)="deleteDadProductPrice(price, dadProduct)">
                              <i class="fa fa-trash"></i> Delete
                            </button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="bottom-save">
          <button (click)="onSubmit()" *ngIf="action !== 'show'" [disabled]="dadConfigForm.pristine || dadConfigForm.invalid"
                  class="btn btn-primary">
            <i class="fa fa-save mr-1"></i>Save
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
